import { render } from "./DropdownCustom.vue?vue&type=template&id=1fa52c34"
import script from "./DropdownCustom.vue?vue&type=script&lang=js"
export * from "./DropdownCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__